import React from 'react';
import PropTypes from 'prop-types';
import { Button, HeadingText, BodyText } from '@paypalcorp/pp-react';
import { appendCdnHostName } from '../../../../utility/geoUtils';
import { Message } from '@paypalcorp/worldready-react';
import { useSelector } from 'react-redux';
import { useIsMobile } from '../../../../utility/isMobile';

const Login = ({ handleLogin, handleSignUp }) => {
  const isMobile = useIsMobile();

  const showLandingCampaignsContent = useSelector(
    (state) => state?.application?.showLandingCampaignsContent || false
  );

  return (
    <div className="login-header-container">
      <div className="button-container">
        <HeadingText
          size={isMobile ? 'lg' : 'display'}
          className="button-container-header"
        >
          {!showLandingCampaignsContent ? (
            <Message id="buttonsV3.login.header.title" />
          ) : (
            <Message id="buttonsV3.login.header.campaign.title" />
          )}
        </HeadingText>
        <BodyText className="button-container-body">
          {!showLandingCampaignsContent ? (
            <Message id="buttonsV3.login.header.body" />
          ) : (
            <Message id="buttonsV3.login.header.campaign.body" />
          )}
        </BodyText>
        <Button
          className="login-button"
          id="button-factory-login"
          type="submit"
          onClick={handleLogin}
        >
          <Message id="buttonsV3.login.loginButton" />
        </Button>
        <Button secondary onClick={handleSignUp} id="button-factory-signup">
          <Message id="buttonsV3.login.signUp" />
        </Button>
      </div>
      <div className="image-container">
        <img
          src={appendCdnHostName(
            '/paypal-ui/illustrations/focused/svg/donate-button-desktop-mobile.svg'
          )}
          role="presentation"
        />
      </div>
    </div>
  );
};

Login.propTypes = {
  handleLogin: PropTypes.func,
  handleSignUp: PropTypes.func,
};

export default Login;
